var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from './svg-circle-icon';
export var DownloadIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 36,
    glyphHeight: 54,
    glyphOffsetY: 2
  }), React.createElement("path", {
    d: "M22.1738 37.4579V9.22134H34.779V0.873517H22.1738V0.790039H13.826V0.873517H1.22075V9.22134H13.826V37.4579L6.1877 29.8196L0.281616 35.7257L17.9999 53.4231L35.7181 35.7257L29.8121 29.8196L22.1738 37.4579Z"
  }));
};
export var DownloadIconGlyph = function (props) {
  return React.createElement(DownloadIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};